// contabilidadService - Sprint 44 Fase 3 Vista 8.
// Service migrado desde modules/contabilidad/services/contabilidadService.js.
// Cero cambios funcionales. Mismo contrato API backend.
import apiClient from '../../../api/apiClient';

const B = '/contabilidad';

// -------- Cuentas --------
export async function listCuentas({ tipo = '', solo_hojas = false, activo = '', q = '' } = {}) {
  const p = new URLSearchParams();
  if (tipo) p.set('tipo', tipo);
  if (solo_hojas) p.set('solo_hojas', 'true');
  if (activo !== '') p.set('activo', activo);
  if (q) p.set('q', q);
  const r = await apiClient.get(B + '/cuentas/?' + p.toString());
  return (r && r.data && r.data.items) || [];
}

export async function treeCuentas() {
  const r = await apiClient.get(B + '/cuentas/tree');
  return (r && r.data && r.data.items) || [];
}

export async function getCuenta(id) {
  const r = await apiClient.get(B + '/cuentas/' + id);
  return (r && r.data) || null;
}

export async function createCuenta(payload) {
  const r = await apiClient.post(B + '/cuentas/', payload);
  return (r && r.data) || null;
}

export async function updateCuenta(id, payload) {
  const r = await apiClient.put(B + '/cuentas/' + id, payload);
  return (r && r.data) || null;
}

export async function toggleCuenta(id, activar) {
  if (activar) return apiClient.post(B + '/cuentas/' + id + '/activar', {});
  return apiClient.delete(B + '/cuentas/' + id);
}

// -------- Asientos --------
export async function listAsientos({ page = 1, per_page = 25, estado = '', modulo = '', desde = '', hasta = '', q = '' } = {}) {
  const p = new URLSearchParams();
  p.set('page', page); p.set('per_page', per_page);
  if (estado) p.set('estado', estado);
  if (modulo) p.set('modulo', modulo);
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  if (q) p.set('q', q);
  const r = await apiClient.get(B + '/asientos/?' + p.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function getAsiento(id) {
  const r = await apiClient.get(B + '/asientos/' + id);
  return (r && r.data) || null;
}

export async function createAsiento(payload) {
  const r = await apiClient.post(B + '/asientos/', payload);
  return (r && r.data) || null;
}

export async function updateAsiento(id, payload) {
  const r = await apiClient.put(B + '/asientos/' + id, payload);
  return (r && r.data) || null;
}

export async function deleteAsiento(id) {
  return apiClient.delete(B + '/asientos/' + id);
}

export async function publicarAsiento(id) {
  const r = await apiClient.post(B + '/asientos/' + id + '/publicar', {});
  return (r && r.data) || null;
}

// -------- Lineas/Movimientos --------
export async function listLineas(aid) {
  const r = await apiClient.get(B + '/asientos/' + aid + '/lineas');
  return (r && r.data && r.data.items) || [];
}

export async function createLinea(aid, payload) {
  const r = await apiClient.post(B + '/asientos/' + aid + '/lineas', payload);
  return (r && r.data) || null;
}

export async function updateLinea(lid, payload) {
  const r = await apiClient.put(B + '/movimientos/' + lid, payload);
  return (r && r.data) || null;
}

export async function deleteLinea(lid) {
  return apiClient.delete(B + '/movimientos/' + lid);
}

// -------- Reportes --------
export async function balanceGeneral(fecha) {
  const p = new URLSearchParams();
  if (fecha) p.set('fecha', fecha);
  const r = await apiClient.get(B + '/reportes/balance-general?' + p.toString());
  return (r && r.data) || null;
}

export async function estadoResultados(desde, hasta) {
  const p = new URLSearchParams();
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  const r = await apiClient.get(B + '/reportes/estado-resultados?' + p.toString());
  return (r && r.data) || null;
}

export async function libroMayor(cuenta_id, desde, hasta) {
  const p = new URLSearchParams({ cuenta_id: String(cuenta_id) });
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  const r = await apiClient.get(B + '/reportes/libro-mayor?' + p.toString());
  return (r && r.data) || null;
}

export async function auxiliarTercero({ tercero_tipo = '', tercero_id = '', desde = '', hasta = '' } = {}) {
  const p = new URLSearchParams();
  if (tercero_tipo) p.set('tercero_tipo', tercero_tipo);
  if (tercero_id) p.set('tercero_id', tercero_id);
  if (desde) p.set('desde', desde);
  if (hasta) p.set('hasta', hasta);
  const r = await apiClient.get(B + '/reportes/auxiliar-tercero?' + p.toString());
  return (r && r.data) || null;
}
